import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import isEmpty from 'lodash/isEmpty'

import SidebarSection from 'components/Shared/Sidebar/SidebarSection/Index'
import SidebarLink from 'components/Shared/Sidebar/SidebarLink/Index'

import {
  RouteTicketProviderTicket,
  RouteTicketingSystemsTicket,
} from 'routes'

const SidebarTicketParent = ({ parentTicket, ticketProviderId, ticketingSystemDisplayId }) => {
  const { t } = useTranslation()

  if (isEmpty(parentTicket)) {
    return null
  }

  let parentTicketUrl = ''

  if (ticketProviderId) {
    parentTicketUrl = RouteTicketProviderTicket({
      ticketProviderId: ticketProviderId,
      ticketId: parentTicket.number,
    })
  }

  if (ticketingSystemDisplayId) {
    parentTicketUrl = RouteTicketingSystemsTicket({
      ticketingSystemDisplayId: ticketingSystemDisplayId,
      ticketId: parentTicket.number,
    })
  }

  return (
    <SidebarSection
      title={t('ticketPage.sidebarSectionParent')}
      copyText={parentTicket.number}
    >
      <SidebarLink
        text={`${parentTicket.number}: ${parentTicket.title}`}
        linkTo={{ pathname: parentTicketUrl }}
      />
    </SidebarSection>
  )
}

SidebarTicketParent.propTypes = {
  parentTicket: PropTypes.object,
  ticketProviderId: PropTypes.string,
  ticketingSystemDisplayId: PropTypes.string,
}

export default SidebarTicketParent
